import{createGlobalStyle as e}from"styled-components";var o=e;export{o as createGlobalStyle};
//# sourceMappingURL=createGlobalStyle.js.map
